import React from "react";
import {
  Calendar,
  CheckCircle,
  Clock,
  FileUp,
  Palette,
  PlayCircle,
  Users,
} from "lucide-react";
import Navbar from "../components/NavLite";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import BgImage from "../assets/newimages/newimage7.jpg";
import BookingImg from "../assets/Services/Booking App Template.png";
import NourivImg from "../assets/Services/NourivPlatform.png";
import WaitlistImg from "../assets/Services/Waitlist App Template.png";


function BookingApp() {
  return (
    <div className="bg-white text-gray-900 font-inter">
 <Helmet>
  <title>Booking Website Template App for Women Entrepreneurs | Woaom Web Design</title>
  <meta
    name="description"
    content="Woaom Web Design’s Booking Website Template App helps coaches, creatives, and women entrepreneurs book clients with ease. Professional, mobile-first, and SEO-ready for founders in Dallas, Houston, Austin, Atlanta, New York City, and more."
  />
  <meta
    name="keywords"
    content="Booking website template Dallas TX, Houston TX booking app for women entrepreneurs, Austin TX website template for service providers, Atlanta GA booking site design, New York City booking website app, Washington DC booking website template, Philadelphia PA booking website for women founders, Memphis TN booking app template, Baton Rouge LA booking site for women-led businesses, Shreveport LA booking website app, New Orleans booking template website, Macon GA booking app for service providers, Augusta GA booking site template for coaches, Baltimore MD booking website template, custom booking app Dallas women entrepreneurs, mobile-first booking website Houston TX, SEO booking template Austin TX, professional booking website Atlanta GA, scalable booking app New York City founders, conversion-focused booking site Washington DC, feminine booking website Philadelphia PA, easy booking site Memphis TN women founders, online booking website Baton Rouge LA, streamlined booking app Shreveport LA, fast launch booking site New Orleans, women entrepreneur booking app Macon GA, creative booking website Augusta GA, founder-friendly booking app Baltimore, modern booking website for women entrepreneurs Texas, template booking app for coaches and creatives"
  />
</Helmet>


      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center bg-no-repeat py-10 px-4 sm:px-6 lg:px-8 text-center shadow-lg"
        style={{ backgroundImage: `url(${BgImage})` }}
      >
        <Navbar />
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
            Book More Clients — Without the Back & Forth
          </h1>
          <p className="text-xl sm:text-2xl text-white opacity-90 mb-8 max-w-2xl mx-auto">
            The Booking Website Template App is your fully branded, high-vibe
            booking flow — built to impress and convert.
          </p>
          <p className="text-md sm:text-lg text-white opacity-80 mb-10 max-w-3xl mx-auto">
            Whether you're a coach, consultant, creative, or wellness pro —
            this sleek, Firebase-hosted app makes it simple to schedule calls,
            collect payments, and show off your brand.
          </p>
          <a
            href="https://woaomtemplatetwo.web.app/"
            className="inline-flex items-center text-black bg-[#CFF098] rounded-full px-6 py-2 border border-black"
          >
            View Demo →
          </a>
        </div>
      </section>

      {/* Product Summary */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src={BookingImg}
              alt="Booking App Template Preview"
              className="shadow-lg rounded-lg"
            />
          </div>
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              Booking Website Template App
            </h2>
            <p className="text-gray-700 mb-4">
              Designed for entrepreneurs who want to look pro while making it
              easy for clients to book, pay, and get confirmation—all in one
              place.
            </p>
            <p className="text-lg font-bold text-[#2E2D2B] mb-6">$199.99</p>

            <a
              href="https://buy.stripe.com/6oU28s2uV0ZJ8Hr41P4sE05" // Replace with real Stripe link
              className="inline-block text-black bg-[#CFF098] rounded-full px-6 py-2 border border-black"
              target="_blank"
              rel="noopener noreferrer"
            >
              Buy This App →
            </a>
            <p className="text-sm text-gray-500 mt-4">
              Includes full source code + setup guide
            </p>
          </div>
        </div>
      </section>

      {/* Feature List */}
      <section className="py-12 px-6 bg-gray-50">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-2xl font-semibold mb-6">
            TAKE A PEEK inside the Booking Template
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-left text-gray-700 text-sm">
            <ul className="space-y-2 list-disc list-inside">
              <li>Custom-Branded Booking Page</li>
              <li>Calendly Embedded Flow</li>
              <li>Service Descriptions + Pricing</li>
              <li>Client Confirmation Messaging</li>
            </ul>
            <ul className="space-y-2 list-disc list-inside">
              <li>Optional Stripe Payment Integration</li>
              <li>Mobile-First Responsive Design</li>
              <li>Editable Hero Section + Testimonials</li>
              <li>Deployed on Firebase Hosting</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Longform Description */}
      <section className="py-12 px-6 bg-white">
        <div className="max-w-4xl mx-auto prose prose-lg prose-gray">
          <p>
            No more sending calendar links in DMs or juggling endless emails.
            The Booking App Template turns your scheduling process into a
            seamless, brand-aligned experience.
          </p>
          <p>
            You get a fully editable React + Tailwind app hosted on Firebase,
            built with conversion-focused design in mind. Whether you're
            offering discovery calls, 1:1 services, or intensives — this tool
            makes booking friction-free.
          </p>
        </div>
      </section>

      {/* Related Products */}
      <section className="py-12 px-6 bg-gray-100">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xl font-semibold mb-4">You may also like…</h2>
          <div className="grid sm:grid-cols-3 gap-6">
            <a href="/nouriv">
              <div className="bg-white border text-center rounded-lg shadow-sm">
                <img src={NourivImg} alt="Nouriv Dashboard" className="mb-4" />
                <h3 className="font-semibold">Nouriv Coaching Dashboard</h3>
                <p className="text-[#2E2D2B] font-medium">$199.99</p>
              </div>
            </a>
            <a href="/waitlist">
              <div className="bg-white border text-center rounded-lg shadow-sm">
                <img
                  src={WaitlistImg}
                  alt="Waitlist Funnel"
                  className="mb-4"
                />
                <h3 className="font-semibold">Waitlist Funnel Template</h3>
                <p className="text-[#2E2D2B] font-medium">$97.00</p>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-16 bg-[#F8F8F8] px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl font-semibold text-center mb-10">
            How It Works
          </h2>
          <ol className="space-y-6 text-gray-700 text-sm">
            <li>
              <strong>Step 1:</strong> Purchase the Booking App Template
            </li>
            <li>
              <strong>Step 2:</strong> Customize your services, brand colors, and images
            </li>
            <li>
              <strong>Step 3:</strong> Connect your Calendly and (optional) Stripe
            </li>
            <li>
              <strong>Step 4:</strong> Deploy with Firebase (we show you how)
            </li>
            <li>
              <strong>Step 5:</strong> Start booking dream clients like clockwork 
            </li>
          </ol>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-semibold text-center mb-8">
            Frequently Asked Questions
          </h2>
          <div className="border-b py-4">
            <h3 className="text-lg font-medium">
              Can I use this without coding experience?
            </h3>
            <p className="text-sm mt-2 text-gray-600">
              Yes! We include a simple step-by-step video walkthrough to guide
              you from install to launch.
            </p>
          </div>
          <div className="border-b py-4">
            <h3 className="text-lg font-medium">
              Can I add my own booking tool instead of Calendly?
            </h3>
            <p className="text-sm mt-2 text-gray-600">
              Absolutely. This is a React-based template so you can embed other
              tools like Acuity or TidyCal instead.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        id="get-app"
        className="py-16 px-4 sm:px-6 lg:px-8 text-center bg-gray-50 rounded-b-3xl shadow-lg"
      >
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
            Book Clients with Confidence
          </h2>
          <p className="text-lg text-gray-700 mb-10">
            Get the Booking Website App Template and simplify your service flow
            — starting today.
          </p>
          <a
            href="https://buy.stripe.com/test_a1b2c3d4e5f6g7h8i9"
            className="inline-flex items-center text-black bg-[#CFF098] rounded-full px-6 py-2 border border-black"
            target="_blank"
            rel="noopener noreferrer"
          >
            Buy This App →
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default BookingApp;
